module.exports = __webpack_public_path__ + "static/media/alex.095ae0c6.png";